import { render, staticRenderFns } from "./EditShipment.vue?vue&type=template&id=763b689a"
import script from "./EditShipment.vue?vue&type=script&lang=js"
export * from "./EditShipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports